(function() {
  'use strict';
  
  function initFrameFilter() {
    // Wait a bit for Shopify to fully render
    setTimeout(function() {
      var sizeSelect = document.querySelector('select[name="options[Size]"]') || 
                       document.querySelector('select[name="options[size]"]') ||
                       document.querySelector('select[data-option-name="Size"]') ||
                       document.querySelector('select[data-option-name="size"]');
                       
      var frameSelect = document.querySelector('select[name="options[Frame]"]') || 
                        document.querySelector('select[name="options[frame]"]') ||
                        document.querySelector('select[data-option-name="Frame"]') ||
                        document.querySelector('select[data-option-name="frame"]');

      if (!sizeSelect || !frameSelect) {
        console.log('Selects not found:', {
          sizeSelect: sizeSelect,
          frameSelect: frameSelect
        });
        return;
      }

      console.log('Selects found successfully');

      function applyFilter() {
        var selectedSize = sizeSelect.value;
        var options = frameSelect.options;
        var i, optionText;

        console.log('Selected size:', selectedSize);

        var hasTargetSize = selectedSize.indexOf('75x100 cm / 30x40') !== -1;

        if (hasTargetSize) {
          console.log('Target size detected, filtering...');
          
          for (i = 0; i < options.length; i++) {
            optionText = (options[i].textContent || options[i].innerText || options[i].text || '').trim();
            
            console.log('Option ' + i + ':', optionText);
            
            if (optionText.toLowerCase().indexOf('print only') !== -1) {
              options[i].style.display = 'block';
              options[i].disabled = false;
              console.log('Showing:', optionText);
            } else {
              options[i].style.display = 'none';
              options[i].disabled = true;
              console.log('Hiding:', optionText);
            }
          }
          
          // Select first visible option
          for (i = 0; i < options.length; i++) {
            if (!options[i].disabled && options[i].style.display !== 'none') {
              frameSelect.selectedIndex = i;
              
              // Trigger change multiple ways for Safari
              var changeEvent;
              try {
                changeEvent = new Event('change', { bubbles: true });
                frameSelect.dispatchEvent(changeEvent);
              } catch (e) {
                changeEvent = document.createEvent('HTMLEvents');
                changeEvent.initEvent('change', true, false);
                frameSelect.dispatchEvent(changeEvent);
              }
              
              // Also trigger Shopify-specific events
              if (typeof jQuery !== 'undefined') {
                jQuery(frameSelect).trigger('change');
              }
              
              break;
            }
          }
        } else {
          console.log('Showing all options');
          for (i = 0; i < options.length; i++) {
            options[i].style.display = 'block';
            options[i].disabled = false;
          }
        }
      }

      if (sizeSelect.addEventListener) {
        sizeSelect.addEventListener('change', applyFilter, false);
      } else if (sizeSelect.attachEvent) {
        sizeSelect.attachEvent('onchange', applyFilter);
      }
      
      applyFilter();
    }, 500);
  }

  if (document.readyState === 'loading') {
    if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', initFrameFilter);
    } else {
      document.attachEvent('onreadystatechange', function() {
        if (document.readyState === 'complete') {
          initFrameFilter();
        }
      });
    }
  } else {
    initFrameFilter();
  }
})();